<template>
    <div class="page-contact">
        <vue-headful 
            :title="$PPlusEngine.getDictionary($route.params.lang, 
                'ติดต่อเรา - ProbPlus', 
                'ติดต่อเรา - ProbPlus')" 
            :description="$PPlusEngine.getDictionary($route.params.lang, 
                'ส่งข้อความได้ที่ support@probplus.com หรือติดต่อ 06-5617-6123',
                'ส่งข้อความได้ที่ support@probplus.com หรือติดต่อ 06-5617-6123')" />
        <div class="top-title">
            <div class="container">
                <h1>{{ $PPlusEngine.getDictionary($route.params.lang, 'ติดต่อเรา', 'Contact Us') }}</h1>
            </div>
        </div>
        <div class="container">
            <div class="global-box-content">
                <div class="row">
                    <div class="col-sm-12 col-md-5">
                        <section class="channel">
                            <h2><i class="pe-7s-headphones"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ช่องทางการติดต่อ', 'Contact Channel') }}</h2>
                            <ul>
                                <li>
                                    <font-awesome-icon :icon="['fas', 'phone']" />
                                    <span>06-5617-6123</span>
                                </li>
                                <li>
                                    <a href="https://www.facebook.com/ProfessionalBePositive" target="_blank">
                                        <font-awesome-icon :icon="['fab', 'facebook-f']" />
                                        <span>Facebook Page</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="mailto:support@probplus.com" target="_blank">
                                        <font-awesome-icon :icon="['fas', 'envelope']" />
                                        <span>support@probplus.com</span>
                                    </a>
                                </li>
                            </ul>
                        </section>
                    </div>
                    <div class="col-sm-12 col-md-7">
                        <section class="form">
                            <h2><i class="pe-7s-mail"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ส่งข้อความ', 'Send Message') }}</h2>
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'ชื่อผู้ติดต่อ', 'Contact Name') }}</label>
                                        <div class="input-icon">
                                            <input type="text" class="form-control" :placeholder="$PPlusEngine.getDictionary($route.params.lang, 'ชื่อผู้ติดต่อ', 'Contact Name')" maxlength="100" :class="$PPlusEngine.highlightInvalidField(contactValidate.FullName.invalid)" v-model="contactForm.fullName" />
                                            <i class="pe-7s-user"></i>
                                        </div>
                                        <span class="error-message" v-if="contactValidate.FullName.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกชื่อผู้ติดต่อ', 'Please input contact name') }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'อีเมล', 'Email') }}</label>
                                        <div class="input-icon">
                                            <input type="text" class="form-control" :placeholder="$PPlusEngine.getDictionary($route.params.lang, 'อีเมล', 'Email')" maxlength="100" :class="$PPlusEngine.highlightInvalidField(contactValidate.Email.invalid)" v-model="contactForm.email" />
                                            <i class="pe-7s-mail"></i>
                                        </div>
                                        <span class="error-message" v-if="contactValidate.Email.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกอีเมล', 'Please input email') }}</span>
                                        <span class="error-message" v-if="contactValidate.Email.format">{{ $PPlusEngine.getDictionary($route.params.lang, 'รูปแบบอีเมลไม่ถูกต้อง', 'Email is not valid format') }}</span>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'ข้อความ', 'Message') }}</label>
                                        <div class="input-icon">
                                            <i class="pe-7s-pen"></i>
                                            <textarea maxlength="1000" class="form-control" :placeholder="$PPlusEngine.getDictionary($route.params.lang, 'ข้อความ', 'Message')" rows="5" :class="$PPlusEngine.highlightInvalidField(contactValidate.Message.invalid)" v-model="contactForm.message"></textarea>
                                        </div>
                                        <span class="error-message" v-if="contactValidate.Message.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'โปรดกรอกข้อความ', 'Please write your message') }}</span>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <button class="btn btn-main btn-lg" @click="submitContact()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ส่งข้อความ', 'Submit') }}</button>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PPlusNotify from '@/resources/PPlusNotify';

export default {
    mixins: [PPlusNotify],
    components: {
    },
    data() {
        return {
            contactForm: this.initModelContact(),
            contactValidate: this.initValidateContact()
        }
    },
    methods: {
        initModelContact() {
            return { fullName: '', email: '', message: '', langCode: this.$route.params.lang };
        },
        initValidateContact() {
            return { 
                FullName: { invalid: false, blank: false }, 
                Email: { invalid: false, blank: false, format: false },
                Message: { invalid: false, blank: false }
            }
        },
        submitContact() {
            this.contactValidate = this.initValidateContact();

            if (!this.validateField()) {
                let loader = this.$WeHelper.modalLoad();
                let apiURL = this.$PPlusConfig.ApiURL;

                this.$recaptcha('contact').then((token) => {
                    this.contactForm.recaptcha = token;

                    this.$WeHelper.postAPI(apiURL, '/api/contact/submit-contact', this.contactForm).then((response) => {
                        loader.hide();
    
                        if (response.data) {
                            this.$swal({
                                title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ได้รับข้อความเรียบร้อย', 
                                        'ได้รับข้อความเรียบร้อย'),
                                text: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ส่งหลักฐานการโอนเรียบร้อยแล้ว', 
                                        'ทางเราจะติดต่อกลับไปทางอีเมลที่ให้ไว้ภายใน 24 ชั่วโมง'),
                                type: 'success'
                            });
                            
                            this.contactForm = this.initModelContact();
                        }
                        else {
                            this.alertSystemError();
                        }
                    });
                });
            }
        },
        validateField() {
            var isError = false;

            if (!this.contactForm.fullName) {
                this.contactValidate.FullName.invalid = true;
                this.contactValidate.FullName.blank = true;
                isError = true;
            }
            if (!this.contactForm.email) {
                this.contactValidate.Email.invalid = true;
                this.contactValidate.Email.blank = true;
                isError = true;
            }
            if (!this.$WeHelper.validateEmail(this.contactForm.email)) {
                this.contactValidate.Email.invalid = true;
                this.contactValidate.Email.format = true;
                isError = true;
            }
            if (!this.contactForm.message) {
                this.contactValidate.Message.invalid = true;
                this.contactValidate.Message.blank = true;
                isError = true;
            }

            return isError;
        }
    }
};
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-contact {
    padding: 40px 0 50px;

    @media only screen and (max-width: $screenSmall) {
        padding: 30px 0;
    }

    .top-title {
        margin-bottom: 30px;

        h1 {
            margin: 0;
            font-size: 36px;
            font-weight: 200;
            color: #555;
            text-align: center;
        }
    }
    
    h2 {
        margin: 0;
        padding-bottom: 30px;
        font-size: 26px;
        text-align: left;
        color: #000;

        i {
            @include verticalAlign(middle);
            color: $mainColor;
            margin-right: 5px;
        }

        &:after {
            margin-top: 12px;
            width: 100px;
            height: 1px;
            background: $mainColor;
            display: block;
            content: " ";
        }
    }

    .form {
        border-left: 1px solid #ddd;
        padding-left: 40px;

        @media only screen and (max-width: $screenSmall) {
            padding-top: 30px;
            padding-left: 0;
            margin-top: 30px;
            border-top: 1px solid #ddd;
            border-left: none;
        }

        .form-recaptcha {
            margin-top: 0;
        }
    }

    .channel {
        p {
            font-size: 16px;
            margin-bottom: 20px;
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: none;

            li {
                margin: 10px 0;
                font-size: 15px;

                a {
                    display: block;
                    color: #333;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                }

                svg {
                    font-size: 22px;
                    vertical-align: middle;
                    color: #aaa;
                    margin-right: 25px;
                    width: 22px;
                }

                span {
                    color: #000;
                }
            }
        }
    }
}
</style>